import { useRef } from "react";
import { useReveal, useCountUp } from "../hooks/useReveal";

const COUNTERS = [
  { end: 15, suffix: "+", label: "Years of Practice" },
  { end: 1200, suffix: "+", label: "Psychology Clients" },
  { end: 800, suffix: "+", label: "Pranic Healing Sessions" },
  { end: 98, suffix: "%", label: "Client Satisfaction" },
];

function Counter({ end, suffix, label }) {
  const ref = useRef(null);
  useCountUp(ref, end);
  return (
    <div className="counter reveal reveal--up" data-testid={`counter-${label.replace(/\s+/g, '-').toLowerCase()}`}>
      <div>
        <span className="counter__num" ref={ref}>0</span>
        <span className="counter__plus">{suffix}</span>
      </div>
      <div className="counter__label">{label}</div>
    </div>
  );
}

export default function About() {
  const ref = useReveal();
  return (
    <section id="about" className="section about" ref={ref} data-testid="about-section">
      <div className="container">
        <div className="about__grid">
          <div className="about__bio reveal reveal--left">
            <span className="eyebrow">About the Practitioner</span>
            <h2 className="section-title">A clinician's mind, a healer's hands.</h2>
            <span className="divider-leaf">Namaste</span>

            <p style={{ marginTop: 28 }}>
              For over fifteen years, my work has lived at the meeting place of two great
              traditions — the rigour of modern clinical psychology and the ancient,
              wordless intelligence of pranic healing. I trained first as a psychologist,
              then as a healer, and now consider both vocations to be a single practice:
              the art of helping a human being become well in every layer of themselves.
            </p>

            <p>
              In my consulting room, evidence-based therapies — Cognitive Behavioural
              Therapy, Dialectical Behavioural Therapy, REBT, trauma-focused protocols —
              meet the disciplined energy work pioneered by Master Choa Kok Sui. The
              cortex learns new patterns. The subtle body lets go of old ones. Healing,
              when it arrives, arrives more deeply than either modality alone could
              reach.
            </p>

            <p>
              Whether you have come for relief from a specific symptom or for a quieter,
              more spacious way of being inside your own life, you are welcome here.
              Nothing about you is too much, too small, or too late. We will simply begin
              where you are.
            </p>

            <div className="about__signature">
              <span className="about__signature-line" />
              <span className="about__signature-name">Dr. Kalpana Randhawa</span>
            </div>
          </div>

          <div className="counters stagger reveal reveal--right">
            {COUNTERS.map((c) => (
              <Counter key={c.label} {...c} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
